/**
 * User-scoped cart storage utility.
 * Each user gets their own cart key in localStorage so switching accounts
 * doesn't leak cart items between users.
 */

function getCartKey() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user?.user_id || 'guest';
    return `cart_${userId}`;
  } catch {
    return 'cart_guest';
  }
}

export function getCart() {
  try {
    return JSON.parse(localStorage.getItem(getCartKey()) || '[]');
  } catch {
    return [];
  }
}

export function setCart(items) {
  localStorage.setItem(getCartKey(), JSON.stringify(items));
}

export function clearCart() {
  localStorage.removeItem(getCartKey());
}

export function getCartCount() {
  return getCart().length;
}
